module.exports = "<div class=\"region master\" (click)=\"join(region)\"> <div class=\"layout-row layout-align-center\"><i class=\"flex-nogrow icon sm zmdi zmdi-globe\"></i><div class=\"flex content\"><div class=\"title\">{{ region.name }}</div></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/region-element/region-element.component.pug
// module id = 1061
// module chunks = 0